import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import { useTranslation } from "react-i18next";
import EmptyState from "./EmptyState";
import M3Surface from "./M3Surface";
import styles from "./m3.module.css";

/**
 * Card for a chart or analytics panel: title row with a divider, then the body.
 * Shows an EmptyState instead of the body when `isEmpty` is true.
 *
 * @param {string} title
 * @param {string} subtitle
 * @param {React.ReactNode} actions - right-aligned controls (filters, download)
 * @param {boolean} isEmpty
 * @param {string} emptyTitle
 * @param {string} emptyDescription
 * @param {boolean} padded - pad the body (default true)
 * @param {"md"|"sm"} titleSize - "sm" for cards in a dense grid
 */
const ChartCard = ({
  title,
  subtitle,
  actions,
  children,
  isEmpty = false,
  emptyTitle,
  emptyDescription,
  padded = true,
  titleSize = "md",
  elevated = false,
  className = "",
  style,
}) => {
  const { t } = useTranslation();
  return (
    <M3Surface elevated={elevated} className={className} style={style}>
      {(title || actions) && (
        <div className={styles.cardHead}>
          <div className={styles.cardTitles}>
            {title && <h3 className={`${styles.cardTitle} ${titleSize === "sm" ? styles.cardTitleSm : ""}`}>{title}</h3>}
            {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
          </div>
          <span className={styles.cardHeadSpacer} />
          {actions && <div className={styles.cardHeadActions}>{actions}</div>}
        </div>
      )}
      <div className={`${styles.cardBody} ${padded ? styles.cardBodyPadded : ""}`}>
        {isEmpty ? (
          <EmptyState
            plain
            icon={<InsertChartOutlinedIcon />}
            title={emptyTitle || t("No data to display")}
            description={emptyDescription}
          />
        ) : (
          children
        )}
      </div>
    </M3Surface>
  );
};

export default ChartCard;
